import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import ciemReducer from './ciemSlice';

const store = configureStore({
    reducer: {
        auth: authReducer,// Reducer de autenticación
        ciem: ciemReducer,// Reducer de ciem
    },
});

export default store;
